import { CardTypes, } from "@react-components/ui/Cards/card-types";
var getCardTypeByAlias = function (card) {
    switch (card.alias) {
        case "contentPage":
            return CardTypes.ContentCard;
        default:
            return null;
    }
};
export { getCardTypeByAlias };
